import { render, staticRenderFns } from "./tenThemeCard.vue?vue&type=template&id=b9970976&scoped=true"
import script from "./tenThemeCard.vue?vue&type=script&lang=js"
export * from "./tenThemeCard.vue?vue&type=script&lang=js"
import style0 from "./tenThemeCard.vue?vue&type=style&index=0&id=b9970976&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9970976",
  null
  
)

export default component.exports